
//@ts-ignore
import { action, makeObservable, observable, runInAction } from 'mobx';
import { RootStore } from '.';
import { NativeDataInterface } from '@interfaces/basicInfo';
import i18n from '@translate/i18n';
import { errorCaptured, setCookie,getCookie,checkEmptyString, parseJwt } from '@commons/util';
import CONFIG from '@commons/api/config';
import ajax from '@commons/api/ajax';
import { faL } from '@fortawesome/free-solid-svg-icons';
import wx from 'weixin-js-sdk';

const API_ENV = CONFIG.API_ENV;
const API = CONFIG.API;

let instance: BasicInfoStore;

export class BasicInfoStore {
    RootStore: RootStore;
    constructor(RootStore: RootStore) {
        makeObservable(this);
        if (!instance) {
            instance = this;
        }
        this.RootStore = RootStore;
        return instance;
    }

    @observable jwt_token: string = '';
    @observable mgmUser: any = {};
    @observable langTag: string = '';
    @observable nativeData: NativeDataInterface = {};
    @observable mgmRefferCode: string = ''

    // getAccessToken = async () => {
    //     const pps = '769651554';
    //     const body = {
    //         username: pps,
    //         password: '654321',
    //         deviceSystem: 'android',
    //         deviceModel: 'huawei',
    //         deviceVersion: '4.0.1',
    //         saveLogin: false,
    //     };
    //     const HNAT = getCookie('HNAT');
    //     const HNPPS = getCookie('HNPPS');
    //     if ((!checkEmptyString(HNAT) && HNPPS === pps) || API_ENV !== 'development') return [null, null];
    //     let [e, res] = await errorCaptured(() => {
    //         return ajax.post({ url: '/myhkbn-api/login/session', config: { data: body } });
    //     });
    //     if (e) return [e, res];
    //     runInAction(() => {
    //         setCookie('HNPPS', pps);
    //         setCookie('HNAT', res?.data?.accessToken, 30);
    //         setCookie('HNRT', res?.data?.refreshToken, 30);
    //         setCookie('HNRO', res?.data?.role, 30);
    //     });
    //     return [e, res];
    // };

    
    getJwtToken = async () => {
        // let testToken = `eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJNR01QTFVTIiwiYXVkIjoiTUdNUExVUyIsInN1YiI6IlVzZXIgVG9rZW4iLCJpYXQiOjE3MzM3NTQwNzcsImV4cCI6MTczMzc2MTI3NywiTUdNQ09ERSI6IjEyMzQ1Njc4IiwiSE5BVCI6ImZiODk3OTVhLWNiZDYtNDU5YS1iMTgyLTExMTIzMTE2ZTYzMy1mMGJlZjkyNzM0ZTUzZGI5ZTFiMzE2MWMwMTgwZWMyNWQ3MWFlMWEwMmUyYTQ2ZTRmZjU1YmY3ZGE2MGUzNTJiIn0.FrVCDGOVCqbtJd_KJcEJhSMWU7ueZAjaByzuE6y_8nQ`
        let cookieJWT = getCookie("jwt_token");
        let jwt = null;
        if (cookieJWT) {
            jwt = cookieJWT;
        }
        //  else {
        //     jwt = testToken;
        // };

        if (!jwt) return;
        runInAction(() => {
            this.jwt_token = jwt;
            this.mgmUser = parseJwt(jwt);
            console.log(this.jwt_token, this.mgmUser, 'get token');
            setCookie("jwt_token", jwt, parseJwt(jwt).exp);
        });
    }

    getExtraService = async () => {
        const [err, success] = await errorCaptured(
            ajax.get({
                url: API.GET_MGM_CODE
            })
        )
        if (err) {
            return false
        }
        runInAction(() => {
            this.mgmRefferCode = success.data
        })
        return true
    }

    @action
    setLangTag = (lang: string) => {
        runInAction(() => {
            this.langTag = lang;
        })
    }

    @action
    getMGMCode = async () => {
        const [err, success] = await errorCaptured(
            ajax.get({
                url: API.GET_MGM_CODE
            })
        )
        if (err) {
            return false
        }
        runInAction(() => {
            this.mgmRefferCode = success.data
            console.log('mgmRefferCode--2--', success.data)
            console.log('wx.miniProgram--2-', wx.miniProgram)
            if (success.data) {
                if (typeof wx !== 'undefined' && wx.miniProgram) {
                    wx.miniProgram.postMessage({
                        data: { refferCode: success.data, from: 'getMGMCode' }
                    });
                    console.log('post message--2--', success.data)
                } else {
                    console.error('当前环境不支持 wx.miniProgram');
                }
            }
        })
        return true
    }
}
